import script from "./ModalUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalUser.vue?vue&type=script&setup=true&lang=ts"

import "./ModalUser.vue?vue&type=style&index=0&id=c50183da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c50183da"]])

export default __exports__